import './Content4.css';

export default function Content4() {


    return (
        <div     
            style={{
                width:'100vw',
                backgroundColor : 'transparent',    
                display: 'flex',
                flexDirection: 'column',
            }}
            >
                <div
                    style={{
          
                        width:'100vw',
                        height:'3000vh',
                        backgroundColor : 'transparent',    
                     
                    }}
                >

                </div>

                

                <div
                    style={{
     
                        width:'100vw',
                        height:'100vh',
                        backgroundColor : 'red',            
                    }}
                >

                </div>

        </div>
    );
}